import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import {
  addDisclaimersError,
  addDisclaimersSuccess,
  getDisclaimersError,
  getDisclaimersSuccess,
  updateDisclaimersError,
  updateDisclaimersSuccess,
} from './actions'
import {
  DISCLAIMERS_ADD_ASYNC,
  DISCLAIMERS_REQUEST_ASYNC,
  DISCLAIMERS_UPDATE_ASYNC,
} from './constants'

const getDisclaimersEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(DISCLAIMERS_REQUEST_ASYNC.INITIATE).mergeMap(() =>
    api.settings
      .getDisclaimers()
      .map((response) => getDisclaimersSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(getDisclaimersError, error)))
  )

const addDisclaimersEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(DISCLAIMERS_ADD_ASYNC.INITIATE).mergeMap((action) =>
    api.settings
      .addDisclaimer({
        type: action.payload.disclaimer.type,
        text: action.payload.disclaimer.text,
      })
      .map(({ response }) =>
        addDisclaimersSuccess({
          id: response.id,
          tempId: action.payload.disclaimer.id,
        })
      )
      .catch((error) => Observable.of(epicsErrorHandler(addDisclaimersError, error)))
  )

const updateDisclaimersEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(DISCLAIMERS_UPDATE_ASYNC.INITIATE).mergeMap((action) =>
    api.settings
      .updateDisclaimer({
        id: action.payload.disclaimer.id,
        text: action.payload.disclaimer.text,
      })
      .map(() =>
        updateDisclaimersSuccess({
          id: action.payload.disclaimer.id,
        })
      )
      .catch((error) => Observable.of(epicsErrorHandler(updateDisclaimersError, error)))
  )

export default combineEpics(getDisclaimersEpic, addDisclaimersEpic, updateDisclaimersEpic)
